import { Injectable } from '@angular/core';
import  packageJson from '../../../package.json';

@Injectable()
export class AppInfosService {

  constructor() {
  }


  getFrontVersion(): string {
    return packageJson.version;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/app-infos.service.ts